import { render, staticRenderFns } from "./PaymentOrderModal.vue?vue&type=template&id=2995deae&scoped=true"
import script from "./PaymentOrderModal.vue?vue&type=script&lang=js"
export * from "./PaymentOrderModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderModal.vue?vue&type=style&index=0&id=2995deae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995deae",
  null
  
)

export default component.exports